<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">        
        <section 
            v-if="isAdmin()"
            slot="above-content" 
            class="flex flex-ai-c flex-sb"
        >
            <section>
                <button 
                    class="gz-icon_cercle gz-icon_cercle_default gz-icon_cercle_accent"
                    title="очистить фильтры"
                    style="margin-right: 20px"
                    @click="clearFilters(filters)"
                >
                    <span class="icon-cleaning-1"></span>
                </button>
            </section>

            <GZ-BaseButton 
                value="добавить юр лицо"
                class="gz-button gz-button_default" 
                icon="icon-flag" 
                slot="actions"
                @click="addServiceEntity()"
            />
        </section>

        <section slot="content">
            <table class="gz-table">
                <thead class="gz-table__head">
                    <tr class="gz-table__filter-labels">
                        <td class="gz-table__filter-label"><span>Название</span></td>
                        <td class="gz-table__filter-label"><span>Населенный пункт</span></td>
                        <td class="gz-table__filter-label"><span>Улица</span></td>
                        <td class="gz-table__filter-label"><span>Email</span></td>
                        <td class="gz-table__filter-label"><span>Телефон</span></td>
                        <td class="gz-table__filter-label"><span>Комментарий</span></td>
                        <td class="gz-table__filter-label"></td>
                    </tr>
                    <tr class="gz-table__filter">
                        <td>
                            <vue-autosuggest
                                class="gz-text-input gz-vue-autosuggest"
                                :suggestions="suggestionResult"
                                :input-props="{
                                    id: 'serventity-name-input', 
                                    placeholder: filters.name ? filters.name : 'Название'
                                }"
                                @focus="suggestionResult = []"
                                @input="suggestions('name')"
                                @selected="filters.name = selectSuggestionOnSelect(filters, 'name').trim()"
                            ></vue-autosuggest>
                        </td>
                        <td>
                            <vue-autosuggest
                                class="gz-text-input gz-vue-autosuggest"
                                :suggestions="suggestionResult"
                                :input-props="{
                                    id: 'serventity-city-input', 
                                    placeholder: filters.city ? filters.city : 'Город'
                                }"
                                @focus="suggestionResult = []"
                                @input="suggestions('city')"
                                @selected="filters.city = selectSuggestionOnSelect(filters, 'city').trim()"
                            ></vue-autosuggest>
                        </td>
                        <td>
                            <vue-autosuggest
                                class="gz-text-input gz-vue-autosuggest"
                                :suggestions="suggestionResult"
                                :input-props="{
                                    id: 'serventity-address-input', 
                                    placeholder: filters.address ? filters.address : 'Улица'
                                }"
                                @focus="suggestionResult = []"
                                @input="suggestions('address')"
                                @selected="filters.address = selectSuggestionOnSelect(filters, 'address').trim()"
                            ></vue-autosuggest>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr 
                        v-for="(item, $index) in serviceEntitiesList" 
                        :key="$index"
                        class="gz-table__row gz-table__row_default">
                        <td><span>{{ item.attributes.name }}</span></td>
                        <td><span>{{ item.attributes.city }}</span></td>
                        <td><span>{{ item.attributes.address }}</span></td>
                        <td><span>{{ item.attributes.email }}</span></td>
                        <td><span>{{ item.attributes.phone }}</span></td>
                        <td><span>{{ item.attributes.about }}</span></td>
                        <td align="center">
                            <button
                                v-if="isAdmin()"
                                class="gz-icon_cercle gz-icon_cercle_default"
                                @click="$router.push(item.id + '/info')"
                            >
                                <span class="icon-pencil"></span>
                            </button>
                        </td>
                    </tr>
                    <infinite-loading 
                        :identifier="infiniteId" 
                        @infinite="infiniteHandler"
                    ></infinite-loading>
                </tbody>
            </table>
        </section>
    </gz-auth-view-template>
</template>

<script>
import AddServiceEntity from '@/components/custom/admin/views/service-entity/AddServiceEntity'

export default {
    name: 'ServiceEntityList',

    data() {
        return {
            filters: {
                name: null,
                city: null,
                address: null
            },
            serviceEntitiesList: [],
            suggestionResult: [],

            //Pagination
            page: 0,
            infiniteId: +new Date()
        }
    },
    mounted() {
        this.$store.dispatch('serviceEntitiesGet', this.filters)
            .then(() => {
                this.serviceEntitiesList = this.$store.getters['serviceEntitiesList']
            })

    },
    methods: {
        addServiceEntity() {
            this.$store.dispatch('modalOpen', {
                component: AddServiceEntity
            })
        },
        infiniteHandler($state) {
            const filters = this.filters
            
            this.$axios({
                method: 'GET',
                url: 'svcentity',
                params: {
                    pg: this.page, 
                    batch: 5, 
                    name: filters.name,
                    city: filters.city, 
                    address: filters.address
                }
            })
            .then(({data}) => {
                if (data.data.length) {
                    this.page += 1
                    this.serviceEntitiesList.push(...data.data)
                    $state.loaded()
                } else {
                    $state.complete()
                }
            })
            .catch(err => {
                console.error('Ошибка вывода списка юрлиц: ', err)
            })
        },     
        suggestions(param) {
            let input = event.target.value
            
            if (input.length >= 2) {
                setTimeout(() => {
                    this.$axios({
                        method: 'GET',
                        url: 'svcentity',
                        params: {
                            pg: 0,
                            batch: 10,
                            [param]: input
                        }
                    })
                    .then(response => {
                        this.suggestionResult = []
                        
                        let x = []
                        response.data.data.forEach(item => {
                            x.push(item.attributes[param])
                        })

                        //Уберем дубликаты
                        let y = x.filter((item, index) => {
                            return x.indexOf(item) == index
                        })

                        this.suggestionResult.push({data: y})
                    })
                }, 1000)
            }

            if (input.length < 2) {
                this.suggestionResult = []
            }
        },
        selectSuggestionOnSelect() {
            return  event.target.value || event.target.innerHTML
        },
        clearFilters() {
            let obj = this.filters

            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    obj[key] = null
                }
            }

            this.filter = obj
        }
    },
    watch: {
        filters: {
            handler(val) {
                this.page = 0
                this.serviceEntitiesList = []
                this.infiniteId += 1
            },
            deep: true
        }
    }
}
</script>